export function montarProdutosPayload(produtos, rpl) {
  return (produtos || []).map(produto => ({
    codigo: produto.codigo,
    descricao: produto.descricao,
    ...(rpl ? { rpl } : {}),
    quantidade: 1,
  }));
}
